import React from "react";
import "../Menu.css";
import Footer from "./footer";
import Homecarousel from "./homecarousel";
import Navbar from "./navbar";

const Sajeev = () => {
  return (
    <>
      <Navbar />
      <Homecarousel />

      <div className="container">
        <center>
          <div>
            <h2 className="heading-p1">Dr. M.Sajeev</h2>
          </div>
          <div>
            <h6 className="heading-p2">Expert on Post Harvest Standards</h6>
          </div>
          <div>
            <img className="image" src="../images/sajeev.jpg" alt="" />
          </div>
        </center>
      </div>
      <div className="row">
        <div className="col containerin">
          <b>Present</b>
          <br />
          <span>Director, Mam Consultants.</span>
          <br />
          <br />
          <b>Past</b>
          <br />
          <span>
            26 years of experience in various food safety standards through
            consultancy and capacity building services. Expert on global food
            safety standards such as ISO 9001, ISO 22000, BRC, FSSC 22000,
            Environmental management and Occupational health and safety
            management system.
          </span>
          <br />
          <br />
          <div style={{ marginBottom: "10px" }}>
            <b>Educational Qualification</b>{" "}
            <ul className="ulstyle">
              <li>B.Sc. – Botany.</li>
              <li>Masters Degree In Management </li>
              <li>Ph.D. – ( ISO 9000 QMS)</li>
              <li>M.Phil./ Ph.D. – Guide.</li>
            </ul>
          </div>
          <div style={{ marginBottom: "10px" }}>
            <b>Technical Qualification</b>{" "}
            <ul className="ulstyle">
              <li>ISO 9001:2015 – Lead Auditor</li>
              <li>ISO 14001:2015 – Lead Auditor </li>
              <li>ISO 45001:2018 – Lead Auditor </li>
              <li>ISO 22000:2018 – Lead Auditor </li>
              <li>FSSC 22000 V6 – Lead Auditor </li>
              <li>BRCGS – Food V9 </li>
              <li>BRCGS-Packaging V6</li>
              <li>PCQI – US-FDA</li>
            </ul>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Sajeev;
